"use strict";

var _interopRequireDefault = require("/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Checkbox = void 0;
var _defineProperty2 = _interopRequireDefault(require("/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty.js"));
var _objectWithoutProperties2 = _interopRequireDefault(require("/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js"));
var _react = _interopRequireDefault(require("react"));
var _classnames3 = _interopRequireDefault(require("classnames"));
var _Input = require("../input/Input");
var _Tooltip = require("../../components/tooltip/Tooltip");
var _infoCircle = require("../../assets/icons/info-circle.svg");
var _checkboxModule = _interopRequireDefault(require("./checkbox.module.scss"));
var _excluded = ["id", "className", "label", "labelClassName", "description", "value", "checked", "tooltip", "disabled"];
var Checkbox = function Checkbox(_ref) {
  var _classnames;
  var id = _ref.id,
    className = _ref.className,
    label = _ref.label,
    labelClassName = _ref.labelClassName,
    description = _ref.description,
    value = _ref.value,
    checked = _ref.checked,
    tooltip = _ref.tooltip,
    disabled = _ref.disabled,
    allOtherProps = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  return /*#__PURE__*/_react.default.createElement("div", {
    onClick: function onClick(e) {
      e.stopPropagation();
    },
    className: (0, _classnames3.default)(_checkboxModule.default['checkbox'], className)
  }, /*#__PURE__*/_react.default.createElement(_Input.Input, Object.assign({}, allOtherProps, {
    id: id,
    value: value,
    extensionProps: {
      type: 'checkbox',
      checked: checked,
      autoComplete: 'off'
    },
    disabled: disabled,
    className: _checkboxModule.default['checkbox__native-element']
  })), /*#__PURE__*/_react.default.createElement("label", {
    htmlFor: id,
    role: "checkbox",
    className: (0, _classnames3.default)(_checkboxModule.default['checkbox__styled-element'], (_classnames = {}, (0, _defineProperty2.default)(_classnames, _checkboxModule.default['checkbox__styled-element--disabled'], disabled), (0, _defineProperty2.default)(_classnames, _checkboxModule.default['checkbox__styled-element--checked'], checked), _classnames))
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: _checkboxModule.default['checkbox__label-container']
  }, label && /*#__PURE__*/_react.default.createElement("label", {
    htmlFor: id,
    className: (0, _classnames3.default)(_checkboxModule.default['checkbox__label'], labelClassName, (0, _defineProperty2.default)({}, _checkboxModule.default['checkbox__label--disabled'], disabled))
  }, label, tooltip && /*#__PURE__*/_react.default.createElement(_Tooltip.Tooltip, {
    size: "medium",
    className: _checkboxModule.default.tooltip,
    title: tooltip
  }, /*#__PURE__*/_react.default.createElement(_infoCircle.ReactComponent, {
    className: _checkboxModule.default['tooltip-icon']
  }))), description && /*#__PURE__*/_react.default.createElement("div", {
    className: _checkboxModule.default['checkbox__description']
  }, description)));
};
exports.Checkbox = Checkbox;